<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div class="title text--secondary mb-5">Ubah Konten</div>
        <ValidationObserver ref="observer">
          <v-form>
            <!-- HOME -->
            <p class="mb-1">
              Home
            </p>
            <div v-for="(item, index) in form.home"
              :key="index">
              <p class="caption text--secondary mb-1" :class="index > 0 ? 'mt-5' : ''">
                Judul Section {{ index + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorHomeTitle${index}`" 
                v-model="item.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ index + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorHomeDesc${index}`" 
                v-model="item.desc" 
                :options="option">
              </quill-editor>
            </div>
            <!-- FEATURED -->
            <p class="mb-1 mt-3">
              Featured
            </p>
            <div v-for="(l,i) in form.featured" :key="'A'+i">
              <div class="mt-3 mb-3">
                <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Gambar {{ i + 1 }}
                </p>
                <form class="mt-1">
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <image-input v-model="featuredImage[i]" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!featuredImage[i]" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.featured[i].urlImage" :alt="form.featured[i].urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.urlImage">
                  {{ error.urlImage }}
                </p>
              </div>
              <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Judul Section {{ i + 1 }}
              </p>
                <quill-editor 
                :ref="`myTextEditorfeaturedTitle${i}`" 
                v-model="l.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ i + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorfeaturedDesc${i}`" 
                v-model="l.desc" 
                :options="option">
              </quill-editor>
            </div>
            <!-- VISI MISI -->
            <p class="mb-1 mt-3">
              Visi Misi
            </p>
            <div v-for="(l,i) in form.vm" :key="'C'+i">
              <div class="mt-3 mb-3">
                <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Gambar {{ i + 1 }}
                </p>
                <form class="mt-1">
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <image-input v-model="vmImage[i]" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!vmImage[i]" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.vm[i].urlImage" :alt="form.vm[i].urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.urlImage">
                  {{ error.urlImage }}
                </p>
              </div>
              <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Judul Section {{ i + 1 }}
              </p>
                <quill-editor 
                :ref=" `myTextEditorvmTitle${i}`" 
                v-model="l.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ i + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorvmDesc${i}`" 
                v-model="l.desc" 
                :options="option">
              </quill-editor>
            </div>
              <!-- CLass Type -->
            <p class="mb-1 mt-3">
              CLass Type
            </p>
            <div v-for="(l,i) in form.classType" :key="'B'+i">
              <div class="mt-3 mb-3">
                <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Gambar {{ i + 1 }}
                </p>
                <form class="mt-1">
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <image-input v-model="classImage[i]" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!classImage[i]" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.classType[i].urlImage" :alt="form.classType[i].urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.urlImage">
                  {{ error.urlImage }}
                </p>
              </div>
              <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Judul Section {{ i + 1 }}
              </p>
                <quill-editor 
                :ref="`myTextEditorclassTypeTitle${i}`" 
                v-model="l.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ i + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorclassTypeDesc${i}`" 
                v-model="l.desc" 
                :options="option">
              </quill-editor>
            </div>

            <!-- VISI MISI PROFIL-->
            <p class="mb-1 mt-3">
              Visi Misi Profil
            </p>
            <div v-for="(l,i) in form.vmp" :key="'C'+i">
              <div class="mt-3 mb-3">
                <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Gambar {{ i + 1 }}
                </p>
                <form class="mt-1">
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <image-input v-model="vmpImage[i]" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!vmpImage[i]" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.vmp[i].urlImage" :alt="form.vmp[i].urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                class="caption text-left mt-1 red--text"
                  v-show="error.urlImage">
                  {{ error.urlImage }}
                </p>
              </div>
              <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Judul Section {{ i + 1 }}
              </p>
               <quill-editor 
                :ref="`myTextEditorvmpTitle${i}`" 
                v-model="l.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ i + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorvmpDesc${i}`" 
                v-model="l.desc" 
                :options="option">
              </quill-editor>
            </div>
            <!-- TELP & EMAIL -->
            <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
              <v-text-field
                class="mt-7"
                color=" #fc2d63"
                dense
                outlined
                label="Email"
                type="email"
                v-model="form.contact.email"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Telepon" rules="required|min:8|max:13" v-slot="{ errors }">
              <v-text-field
                color=" #fc2d63"
                dense
                outlined
                label="Telepon"
                type="number"
                v-model="form.contact.phoneNumber"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
            <!-- HELP -->
            <p class="mb-1">
              Bantuan
            </p>
            <p class="caption text--secondary mb-1">
              Judul
            </p>
            <quill-editor 
              ref="myTextEditorHelpTitle" 
              v-model="form.help.title"
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.help.title">
              {{ error.help.title }}
            </p>
            <p class="caption text--secondary mt-5 mb-1">
              Deskripsi
            </p>
            <quill-editor 
              ref="myTextEditorHelpDesc" 
              v-model="form.help.desc" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.help.desc">
              {{ error.help.desc }}
            </p>
            <!-- FAQ -->
            <p class="mt-5 mb-1">
              FAQ
            </p>
            <p class="caption text--secondary mb-1">
              Judul
            </p>
            <quill-editor 
              ref="myTextEditorFAQTitle" 
              v-model="form.faq.title" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.faq.title">
              {{ error.faq.title }}
            </p>
            <p class="caption text--secondary mt-5 mb-1">
              Deskirpsi
            </p>
            <quill-editor 
              ref="myTextEditorFAQDesc" 
              v-model="form.faq.desc" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.faq.desc">
              {{ error.faq.desc }}
            </p>
            <!-- FOOTER -->
            <p class="mt-5 mb-1">
              Footer
            </p>
            <quill-editor 
              ref="myTextEditorFooter" 
              v-model="form.footer" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.footer">
              {{ error.footer }}
            </p>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                light
                small
                width="100"
                color="#FF618A"
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                @click="save"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
              <v-btn
                rounded
                small
                width="100"
                elevation="0"
                :disabled="process.form"
                class="text-capitalize"
                @click="dialog.form = false;  $refs.observer.reset()">
                Batal
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <v-row>
          <v-col cols="12" sm="7" class="pb-0">
            <div class="title text--secondary">Konten</div>
          </v-col>
          <v-col cols="12" sm="5" class="text-right pb-0 px-5">
            <v-btn
              :color="!showPage ? '#FF618A' : '#F5F5F5'"
              width="200"
              class="text-capitalize"
              :dark="!showPage"
              elevation="0"
              rounded
              :block="$vuetify.breakpoint.name === 'xs' ? true : false"
              :disabled="process.form"
              :light="showPage"
              v-on:click="$vuetify.breakpoint.name === 'xs' ? dialog.form = true : $vuetify.breakpoint.name === 'sm' ? dialog.form = true : showPage ? showPage = false : showPage = true">
              <span v-if="!showPage">Ubah Konten</span>
              <span v-if="showPage">Kembali</span>
            </v-btn>
          </v-col>
        </v-row>
        <div class="my-2" :class="showPage ? 'pr-5' : 'pl-0'">
          <v-card flat class="align-center line-content my-5 py-4">
            <div 
              v-if="process.run">
              <v-skeleton-loader
                v-for="item in 10" :key="item"
                ref="skeleton"
                type="list-item-two-line"
                class="mx-auto">
              </v-skeleton-loader>
            </div>
            <v-list dense v-if="!process.run">
              <v-list-item
                v-for="(item, index) in form.home"
                :key="index">
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    Home Section {{ index + 1}}
                  </v-list-item-title>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="item.title"></div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="item.desc"></div>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-5"/>
              <v-card-text class="body-2 font-weight-bold grey--text text--darken-2">
                featured 
              </v-card-text>
              <v-card-text>
                <v-row
                  justify="center">
                  <v-col cols="12" md="4"
                    v-for="(l, index) in form.featured"
                    :key="index">
                    <v-card
                      flat
                      class="mx-5 hover-card border-radius text-center pa-5"
                      elevation="0"
                      height="355">
                      <v-avatar size="80">
                        <img :src="l.urlImage"/>
                      </v-avatar>
                      <v-card-title style="width: 98%" class="mx-auto pt-6 pb-1 grey--text text--darken-2 subtitle-1 line-text-first font-weight-bold text-second justify-center" v-html="convert(l.title)">
                      </v-card-title>
                      <v-card-text class="px-10 pt-0 caption text-second line-text-second" v-html="convert(l.desc)">
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider class="ma-5"/>

              <v-card-text class="body-2 font-weight-bold grey--text text--darken-2 pb-1">
                Visi dan Misi 
              </v-card-text>
              <v-card-text class="pt-0">
                <v-row>
                  <v-col cols="12" md="6" class="mt-0">
                    <div class="caption line-text-second grey--text text--darken-2" v-html="convert(form.vm[2].desc)">
                    </div>
                    <v-list style="background: transparent;">
                      <v-list-item
                        v-for="(l, index) in form.vm"
                        :key="index"
                        class="mb-3">
                        <img
                          height="auto"
                          v-if="index < 2"
                          :src="l.urlImage">
                        <v-list-item-content class="ml-3" v-if="index < 2">
                          <v-list-item-title class="grey--text text--darken-2 body-2 font-weight-bold" style="color: rgb(98, 183, 176);" v-html="convert(l.title)"> 
                          </v-list-item-title>
                          <div class="grey--text text--darken-2 caption text-second" v-html="convert(l.desc)">
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-img
                      width="80%"
                      height="auto"
                      class="mx-auto"
                      :src="form.vm[2].urlImage">
                    </v-img>
                  </v-col>
                </v-row>
              </v-card-text>

               <!-- <v-list-item
                v-for="(l, i) in form.vm"
                :key="'C'+i">
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                   Visi Misi Section {{ i + 1}}
                  </v-list-item-title>
                  <div>
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <v-img :src="l.urlImage" style="border-radius: 5px;"></v-img>
                  </v-card>
                  </div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="l.title"></div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="l.desc"></div>
                </v-list-item-content>
              </v-list-item> -->
              <!-- <v-divider class="ma-5"/> -->
              <v-list-item
                v-for="(l, i) in form.classType"
                :key="'B'+i">
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    Type Class Section {{ i + 1}}
                  </v-list-item-title>
                  <div>
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <v-img :src="l.urlImage" style="border-radius: 5px;"></v-img>
                  </v-card>
                  </div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="l.title"></div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="l.desc"></div>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-5"/>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    Telepon
                  </v-list-item-title>
                  <v-list-item-subtitle class="mt-2 d-flex">
                    <v-icon small class="mr-2">mdi-phone</v-icon>
                    <span>
                      {{ form.contact.phoneNumber }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    Email
                  </v-list-item-title>
                  <v-list-item-subtitle class="mt-2 d-flex">
                    <v-icon small class="mr-2">mdi-email</v-icon>
                    <span>
                      {{ form.contact.email }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-5"/>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    Bantuan
                  </v-list-item-title>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="form.help.title"></div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="form.help.desc"></div>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    FAQ
                  </v-list-item-title>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="form.faq.title"></div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="form.faq.desc"></div>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-5"/>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    Footer
                  </v-list-item-title>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="form.footer"></div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" sm="4" class="mt-6 background-default pa-7" v-if="showPage && $vuetify.breakpoint.name !== 'xs'">
        <div class="title text--secondary mb-5">Ubah Konten</div>
        <ValidationObserver ref="observer">
          <v-form>
            <!-- HOME -->
            <p class="mb-1">
              Home
            </p>
            <div v-for="(item, index) in form.home"
              :key="index">
              <p class="caption text--secondary mb-1" :class="index > 0 ? 'mt-5' : ''">
                Judul Section {{ index + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorHomeTitle${index}`" 
                v-model="item.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ index + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorHomeDesc${index}`" 
                v-model="item.desc" 
                :options="option">
              </quill-editor>
            </div>

            <!-- FEATURED -->
            <p class="mb-1 mt-3">
              Featured
            </p>
            <div v-for="(l,i) in form.featured" :key="'A'+i">
              <div class="mt-3 mb-3">
                <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Gambar {{ i + 1 }}
                </p>
                <form class="mt-1">
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <image-input v-model="featuredImage[i]" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!featuredImage[i]" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.featured[i].urlImage" :alt="form.featured[i].urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.urlImage">
                  {{ error.urlImage }}
                </p>
              </div>
              <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Judul Section {{ i + 1 }}
              </p>
               <quill-editor 
                :ref="`myTextEditorfeaturedTitle${i}`" 
                v-model="l.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ i + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorfeaturedDesc${i}`" 
                v-model="l.desc" 
                :options="option">
              </quill-editor>
            </div>

            <!-- VISI MISI -->
            <p class="mb-1 mt-3">
              Visi Misi
            </p>
            <div v-for="(l,i) in form.vm" :key="'C'+i">
              <div class="mt-3 mb-3">
                <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Gambar {{ i + 1 }}
                </p>
                <form class="mt-1">
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <image-input v-model="vmImage[i]" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!vmImage[i]" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.vm[i].urlImage" :alt="form.vm[i].urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                class="caption text-left mt-1 red--text"
                  v-show="error.urlImage">
                  {{ error.urlImage }}
                </p>
              </div>
              <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Judul Section {{ i + 1 }}
              </p>
               <quill-editor 
                :ref="`myTextEditorvmTitle${i}`" 
                v-model="l.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ i + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorvmDesc${i}`" 
                v-model="l.desc" 
                :options="option">
              </quill-editor>
            </div>

             <!-- CLass Type -->
            <p class="mb-1 mt-3">
              CLass Type
            </p>
            <div v-for="(l,i) in form.classType" :key="'B'+i">
              <div class="mt-3 mb-3">
                <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Gambar {{ i + 1 }}
                </p>
                <form class="mt-1">
                  <v-card flat width="80" class="pa-0" style="background: transparent;">
                    <image-input v-model="classImage[i]" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!classImage[i]" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.classType[i].urlImage" :alt="form.classType[i].urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.urlImage">
                  {{ error.urlImage }}
                </p>
              </div>
              <p class="caption text--secondary mb-1" :class="i > 0 ? 'mt-5' : ''">
                Judul Section {{ i + 1 }}
              </p>
               <quill-editor 
                :ref="`myTextEditorclassTypeTitle${i}`" 
                v-model="l.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section {{ i + 1 }}
              </p>
              <quill-editor 
                :ref="`myTextEditorclassTypeDesc${i}`" 
                v-model="l.desc" 
                :options="option">
              </quill-editor>
            </div>

            <!-- TELP & EMAIL -->
            <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
              <v-text-field
                class="mt-7"
                color=" #fc2d63"
                dense
                outlined
                label="Email"
                type="email"
                v-model="form.contact.email"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Telepon" rules="required|min:8|max:13" v-slot="{ errors }">
              <v-text-field
                color=" #fc2d63"
                dense
                outlined
                label="Telepon"
                type="number"
                v-model="form.contact.phoneNumber"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
            <!-- HELP -->
            <p class="mb-1">
              Bantuan
            </p>
            <p class="caption text--secondary mb-1">
              Judul
            </p>
            <quill-editor 
              ref="myTextEditorHelpTitle" 
              v-model="form.help.title" 
              :options="option">
            </quill-editor>
            <p
            class="caption mt-1 mb-1 red--text"
              v-show="error.help.title">
              {{ error.help.title }}
            </p>
            <p class="caption text--secondary mt-5 mb-1">
              Deskripsi
            </p>
            <quill-editor 
              ref="myTextEditorHelpDesc" 
              v-model="form.help.desc" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.help.desc">
              {{ error.help.desc }}
            </p>
            <!-- FAQ -->
            <p class="mt-5 mb-1">
              FAQ
            </p>
            <p class="caption text--secondary mb-1">
              Judul
            </p>
            <quill-editor 
              ref="myTextEditorFAQTitle" 
              v-model="form.faq.title" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.faq.title">
              {{ error.faq.title }}
            </p>
            <p class="caption text--secondary mt-5 mb-1">
              Deskirpsi
            </p>
            <quill-editor 
              ref="myTextEditorFAQDesc" 
              v-model="form.faq.desc" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.faq.desc">
              {{ error.faq.desc }}
            </p>
            <!-- FOOTER -->
            <p class="mt-5 mb-1">
              Footer
            </p>
            <quill-editor 
              ref="myTextEditorFooter" 
              v-model="form.footer" 
              :options="option">
            </quill-editor>
            <p
              class="caption mt-1 mb-1 red--text"
              v-show="error.footer">
              {{ error.footer }}
            </p>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                light
                width="200"
                color="#FF618A"
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                @click="save"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import ImageInput from "../../../../components/ImageInput.vue";
  import Empty from "../../../../components/DataEmpty";
  export default {
    data() {
      return {
        option: {
          modules: {
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        dialog:{
          form: false
        },
        showPage: false,
        form: {
          home : [
            {
              title : "",
              desc : ""
            }
          ],
          featured : [
            {
              urlImage : "",
              title : "",
              desc : ""
            },
            {
              urlImage : "",
              title : "",
              desc : ""
            },
            {
              urlImage : "",
              title : "",
              desc : ""
            }
          ],
          classType : [
            {
              urlImage : "",
              title : "",
              desc : ""
            },
            {
              urlImage : "",
              title : "",
              desc : ""
            },
            {
              urlImage : "",
              title : "",
              desc : ""
            }
          ],
          vm : [
            {
              urlImage : "",
              title : "",
              desc : ""
            },
            {
              urlImage : "",
              title : "",
              desc : ""
            },
            {
              urlImage : "",
              title : "",
              desc : ""
            }
          ],
          footer : "",
          contact : {
            phoneNumber : "",
            email : ""
          },
          help : {
            title : "",
            desc : ""
          },
          faq : {
            title : "",
            desc : ""
          }
        },
        error: {
          footer: "",
          help: {
            title: "",
            desc: ""
          },
          faq : {
            title : "",
            desc : ""
          }
        },
        process: {
          form: false,
          run: false
        },
        classImage:[],
        vmImage:[],
        vmpImage:[],
        featuredImage: [],
        featuredProfilImage: [],
        response: ""
      };
    },
    watch: {
      featuredImage: {
        handler: function (value) {
          for (let i in value) {
            this.form.featured[i].urlImage = this.featuredImage[i] ? this.featuredImage[i].url : ""
            this.error.urlImage = ''
          } 
        },
        deep: true
      },
      classImage: {
        handler: function (value) {
          for(let i in value){
          this.form.classType[i].urlImage = this.classImage[i] ? this.classImage[i].url : ""
          this.error.urlImage = ''
          }
          
        },
        deep: true
      },
      vmImage: {
        handler: function (value) {
          for(let i in value){
          this.form.vm[i].urlImage = this.vmImage[i] ? this.vmImage[i].url : ""
          this.error.urlImage = ''
          }
        },
        deep: true
      }
    },
    components: {
      ImageInput,
      Empty
    },
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        this.process.run = true
        await get(`api/internal/content/detail/5fbc759ad9a773001748e5e8`)
        .then(response => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.form = res.data
            for (let i in this.form.home) {
              this.form.home[i].title = this.form.home[i].title.replace(/&lt;/g, "<")
              this.form.home[i].desc = this.form.home[i].desc.replace(/&lt;/g, "<")
            }
            for (let i in this.form.featured) {
              this.featuredImage[i] = {
                url : this.form.featured[i].urlImage
              }
              this.form.featured[i].title = this.form.featured[i].title.replace(/&lt;/g, "<")
              this.form.featured[i].desc = this.form.featured[i].desc.replace(/&lt;/g, "<")
              this.form.featured[i].urlImage = this.form.featured[i].urlImage
            }
            for (let i in this.form.classType) {
              this.form.classType[i].title = this.form.classType[i].title.replace(/&lt;/g, "<")
              this.form.classType[i].desc = this.form.classType[i].desc.replace(/&lt;/g, "<")
              this.form.classType[i].urlImage = this.form.classType[i].urlImage
            }
            for (let i in this.form.vm) {
              this.vmImage[i] = {
                url : this.form.vm[i].urlImage
              }
              this.form.vm[i].title = this.form.vm[i].title.replace(/&lt;/g, "<")
              this.form.vm[i].desc = this.form.vm[i].desc.replace(/&lt;/g, "<")
              this.form.vm[i].urlImage = this.form.vm[i].urlImage
            }
              this.form.help.title = this.form.help.title.replace(/&lt;/g, "<")
              this.form.help.desc = this.form.help.desc.replace(/&lt;/g, "<")
              this.form.faq.title = this.form.faq.title.replace(/&lt;/g, "<")
              this.form.faq.desc = this.form.faq.desc.replace(/&lt;/g, "<")
              this.form.footer = this.form.footer.replace(/&lt;/g, "<")
          }
        })
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      validation() {
        var error = this.error,
          valid = true
        
        if (this.form.footer === "") {
          error.footer = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.footer = ""
        }

        if (this.form.help.title === "") {
          error.help.title = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.help.title = ""
        }

        if (this.form.help.desc === "") {
          error.help.desc = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.help.desc = ""
        }

        if (this.form.faq.title === "") {
          error.faq.title = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.faq.title = ""
        }

        if (this.form.faq.desc === "") {
          error.faq.desc = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.faq.desc = ""
        }
        return valid;
      },
      async save() {
        this.response = ""
        const valids = this.validation()
        const isValid = await this.$refs.observer.validate()
        if (isValid & valids) {
          this.process.form = true
          await put(`api/internal/content/update/5fbc759ad9a773001748e5e8`, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.code === 201) {
              this.process.form = false
              this.showPage = false
              this.dialog.form = false
              this.fetch()
            } else {
              this.process.form = false
              this.response = res.msg
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
.line-content {
  border-left: 6px solid  #FF618A;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
  transition: 0.3s;
}
</style>